import styled from 'styled-components';

export const MainContentWrapper = styled.div`
  width: 100%;
  max-width: 2048px;
  padding: 20px;
  // overflow: scroll;
  overflow: auto;
`;
